import { api } from '@/api';
import { RootState } from '@/store/index';
import { Category } from '@/types/Category';
import { ActionContext, Module } from 'vuex';

export type CategoriesState = {
    categories: Category[];
};

export const categories: Module<CategoriesState, RootState> = {
    state: {
        categories: [],
    },
    mutations: {
        setCategories(state: CategoriesState, payload) {
            state.categories = payload;
        },
    },
    getters: {
        categories: (state): Category[] => state.categories,
    },
    actions: {
        async fetchCategories(context: ActionContext<CategoriesState, RootState>) {
            const response = await api.get('/categories');

            if (!response || !response.data) {
                throw new Error('Could not load categories');
            }

            context.commit('setCategories', response.data.data);
        },
    },
};
